(function(){

    // Renders a set of ad templates for a Q.Ad model
    Q.AdView = Q.ItemView.extend({
        DEFAULTS: {
            adContainer: '.ad-container',
            clickable: true // clickable ad.
        },

        className: 'ad item',
        templates: {
            // when the view mode is changed, it will render a different
            // template depending.
            thumbs: '#ad-thumbs-template',
            list: '#ad-list-template'
        },

        init: function(c, settings){
            this._super(c, $.extend({}, this.DEFAULTS, settings));

            this.mode = settings.mode || Q.AdView.VIEW_THUMBS;

            // give it a useful id.
            this.container.attr({'id': 'ad-'+this.model.get('id'),'class':this.className});
        },

        render: function(){
            //render template depending on view mode.
            this.template = this.templates[this.mode];
            this._super();

            this.renderer = this.$(this.settings.adContainer).AdRenderer({
                model: this.model,
                clickable: this.settings.clickable
            });

            return this;
        }
    });
    Q.AdView.VIEW_THUMBS = 'thumbs';
    Q.AdView.VIEW_LIST = 'list';

    // Renders the actual ad for a Q.Ad model.
    // if you want the renderers to handle product streams, set
    // Q.AdRenderer.productStreams = some backbone collection of product streams...
    Q.AdRenderer = Q.View.extend('AdRenderer', {
        // settings defaults.
        DEFAULTS: {
            model: null,        // a Q.Ad model
            clickable: true,    //covers the ad so no click action
            flashAdClass: 'ad-thumb-flash gallery-media',
            imageAdClass: 'ad-thumb gallery-media'
        },

        IMAGE_TEMPLATE_NO_CLICK: '<img title="{{name}}" alt="{{ad_format_name}}" src="{{src}}" />',
        IMAGE_TEMPLATE: '<a title="{{name}}" href="{{destination_url}}"><img alt="{{ad_format_name}}" src="{{src}}" /></a>',
        DYNAMIC_HTML5_TEMPLATE: '<canvas id="liquidAdCanvas" width="{{width}}" height="{{height}}"></canvas>',
        PERSONALIZED_HTML5_TEMPLATE: '<iframe src="{{preview_url_with_params}}" frameborder="0" scrolling="no" width="{{width}}" height="{{height}}"></iframe>',
        HTML5_TEMPLATE: '<iframe src="{{preview_url}}?clickTag={{destination_url}}" frameborder="0" scrolling="no" width="{{width}}" height="{{height}}"></iframe>',

        init: function(container, settings){
            _.bindAll(this, 'render');
            this._super(container, $.extend({}, this.DEFAULTS, settings));
            this.model.bind('change', this.render);
            this.model.set({destination_url: encodeURIComponent(this.model.get('destination_url'))});
            var params = window.location.search ? "?" + window.location.search.substring(1) : "";
            this.model.set({preview_url_with_params: this.model.get('preview_url') + params});
            this.render();
        },

        /*
            example: {
                "status":"approved",
                "updated_date":"2011-09-23 22:58:11",
                "advertisable":"E7OQVV6Z6BBE7POHQSYYLT",
                "name":"AA_Liquid_160x600_110914",
                "ad_format":"160 wide x 600 high",
                "src":"http://adroll-main-storage-west-2.s3.amazonaws.com/a/S3D/K2X/S3DK2XNLY5GMFOLHWDTXON.swf",
                "ad_format_name":"160x600 ",
                "is_active":true,
                "has_future_campaigns":null,
                "height":600,
                "width":160,
                "flashvars":{
                    "clickTAG":"http://adroll.com",
                    "pimgtag":"http://localhost/pi/E7OQVV6Z6BBE7POHQSYYLT",
                    "rectag":"http://localhost/rec/E7OQVV6Z6BBE7POHQSYYLT",
                    "prodtag":"http://localhost:8000/p/E7OQVV6Z6BBE7POHQSYYLT/get"
                },
                "eid":"S3DK2XNLY5GMFOLHWDTXON",
                "created_date":"2011-09-14 20:44:08",
                "valid_clicktag":true,
                "type":"flash",
                "destination_url":"http://adroll.com",
                "ad_format_id":7
            }
        */
        _renderFlash: function(){
            var data = this.model.attributes;
            var width = data.width || 300;
            var height = data.height || 250;
            var cont = this.container;

            cont.width(width).height(height);
            cont.html('');
            cont.flash({
                swf: data.src,
                attrs: {'class': this.settings.adClass, 'title': data.title || data.name, 'alt': data.ad_format_name},
                flashvars: this.model.get('flashvars'),
                width: width,
                height: height
            });

            if(this.settings.coverAd){
                //cover flash ads so we cant click on them. Without this cover,
                //the hover action has strange behavior. Sometimes the mouseover
                //would not be called.
                var overlay = $('<div/>').addClass('ad-overlay');
                overlay.css({
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: img.width(),
                    height: img.height()
                });
                cont.append(overlay);
            }
        },
        
        // This will render an image ad. Easy.
        _renderImage: function(){
            this.template = this.IMAGE_TEMPLATE;
            if(!this.settings.clickable)
                this.template = this.IMAGE_TEMPLATE_NO_CLICK;
            return Q.View.prototype.render.call(this);
        },
        _renderDynamicHtml5: function(){
            this.template = this.DYNAMIC_HTML5_TEMPLATE;
            return Q.View.prototype.render.call(this);
        },
        _renderPersonalizedHtml5: function(){
            this.template = this.PERSONALIZED_HTML5_TEMPLATE;
            return Q.View.prototype.render.call(this);
        },
        _renderHtml5: function(){
            this.template = this.HTML5_TEMPLATE;
            return Q.View.prototype.render.call(this);
        },
        render: function(){
            var type = this.model.get('type');
            if(type == 'image' || type == 'native')
                if(this.model.get('is_liquid') == true) {
                    this._renderDynamicHtml5();
                }else {
                    this._renderImage();
                }
            else if(type == 'personalized')
                this._renderPersonalizedHtml5();
            else if(type == 'html5')
                this._renderHtml5();
            else
                this._renderFlash();

            return this;
        }
    });

    // Displays a Q.Ads collection. Does so with style.
    // Responds to change in view modes.
    Q.AdViews = Q.PagedItemViews.extend('AdViews', {
        //set these up so the base class knows how to create stuff.
        viewClass: Q.AdView,
        collectionClass: Q.Ads,

        init: function(c, settings){
            _.bindAll(this, 'changeMode');
            this._super(c, settings);

            if(this.settings.viewMode)
                this.settings.viewMode.bind('change:mode', this.changeMode);
        },

        //When the view mode is changed, re render the page.
        changeMode: function(m, mode){
            // set the mode setting on this object. newPage() will pass it
            // through.
            this.settings.mode = mode;
            this.newPage(this.model);
        }
    });

})();
